export default __webpack_public_path__ + "cock-die-300.png?65a32ed0d519e0cff813b4f2e53d3dc9";